import React from "react";

interface Step { title: string; body: string; }
interface Props { steps?: Step[]; }

const DEFAULT_STEPS: Step[] = [
  { title: "Discover", body: "We discuss lighting, acoustics, and fine-tuning for a system that is right for you and your family." },
  { title: "Design",   body: "A clean plan with the right gear for the room, not the most expensive box on the shelf." },
  { title: "Install",  body: "Tidy wiring, accurate alignment, and respectful work in your home or business." },
  { title: "Support",  body: "We pay attention to details that make a difference and stay reachable for support." },
];

const ProcessStrip: React.FC<Props> = ({ steps = DEFAULT_STEPS }) => (
  <div className="process" data-testid="process-strip">
    {steps.map((s, i) => (
      <div className="process-step" key={s.title}>
        <div className="step-num">{i + 1}</div>
        <h3>{s.title}</h3>
        <p>{s.body}</p>
      </div>
    ))}
  </div>
);

export default ProcessStrip;
